import { render, staticRenderFns } from "./form-category.vue?vue&type=template&id=3f7d7aa2"
import script from "./form-category.vue?vue&type=script&lang=js"
export * from "./form-category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports